import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '../../app-config.service';
import { Observable, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { SalespersonService } from '@vendasta/sales';
import { Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AccessPipelineSettingsGuard {
  private readonly configService = inject(AppConfigService);
  private readonly salespersonService = inject(SalespersonService);
  private readonly router = inject(Router);
  canActivate(): Observable<boolean | UrlTree> {
    return this.configService.config$.pipe(
      switchMap((config) => {
        if ((config.userIsAdmin && config.userCanAccessSales) || config.isSuperAdmin) {
          return of(true);
        } else {
          return this.salespersonService
            .getSalespersonByUserId(config.partnerId, config.unifiedUserId)
            .pipe(map((salesperson) => salesperson?.isSalesManager === true));
        }
      }),
      map((hasAccess) => {
        if (hasAccess) {
          return true;
        } else {
          return this.router.createUrlTree(['pipeline/board']);
        }
      }),
    );
  }
}
